// @flow
import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import SyndicateDashboard from 'screens/SyndicateDashboard';
import SyndicateForm from 'screens/SyndicateForm';
import Login from 'screens/Login';
import ConfirmInvitation from 'screens/ConfirmInvitation';
import { isAuthenticated } from 'helpers/auth';

const PrivateRoute = Component => () => (
  <Route
    render={props =>
      isAuthenticated() ? <Component {...props} /> : <Redirect to="/" />
    }
  />
);

const ConditionalRoutes = (C1, C2) => () => (
  <Route
    render={props =>
      isAuthenticated() ? <C1 {...props} /> : <C2 {...props} />
    }
  />
);

const routes = [
  {
    path: '/',
    exact: true,
    component: ConditionalRoutes(SyndicateDashboard, Login)
  },
  {
    path: '/new',
    exact: true,
    component: PrivateRoute(SyndicateForm)
  },
  {
    path: '/:syndicateId',
    exact: true,
    component: PrivateRoute(SyndicateForm)
  },
  {
    path: '/view/:memberId',
    exact: true,
    component: PrivateRoute(SyndicateForm)
  },
  {
    path: '/confirm-invitation/:token',
    component: ConfirmInvitation
  },
  {
    path: '/login/:token',
    component: Login
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/config/routes.js